<template>
  <div>
    <!-- ユーザー情報入力エリア -->
    <form>
      <div class="p-team-user-edit">
        <!-- 入力 | 選択リスト -->
        <ul class="p-team-user-edit-list">
          <!-- メールアドレス -->
          <li class="p-team-user-edit-list__item">
            <div class="c-input u-w500">
              <div class="c-input__title">メールアドレス（ログインID）</div>
              <input
                v-model="email"
                class="c-input__item"
                type="text"
                name="email"
                value=""
                placeholder="メールアドレスを入力してください"
                :disabled="isEdit"
              />
              <div class="c-error c-error--balloon">
                <div class="c-error__text"></div>
              </div>
            </div>
          </li>
          <!-- /メールアドレス -->
          <!-- 初期パスワード -->
          <li class="p-team-user-edit-list__item p-team-user-edit-list__item--password">
            <template v-if="isEdit">
              <div class="c-checkbox">
                <div class="c-checkbox__title">パスワード初期化</div>
                <ul class="c-checkbox-list">
                  <li class="c-checkbox-list__item">
                    <label class="c-checkbox__label">
                      <input v-model="resetPassword" type="checkbox" name="resetPassword" />
                      <div class="c-checkbox__item">
                        <div class="c-checkbox__box"></div>
                        <div class="c-checkbox__box-label"></div>
                      </div>
                    </label>
                  </li>
                </ul>
                <div class="c-input__text">更新するとランダムな初期パスワードを発行し、完了画面に一度だけ表示します。</div>
              </div>
            </template>
            <template v-else>
              <div class="c-input">
                <div class="c-input__title">初期パスワード</div>
                <div class="c-input__text">登録時にランダムな文字列で発行し、登録後に表示します。初回ログイン時に新しいパスワードへの変更が必要です。</div>
              </div>
            </template>
          </li>
          <!-- /初期パスワード -->
          <!-- 名前 -->
          <li class="p-team-user-edit-list__item">
            <div class="c-input u-w500">
              <div class="c-input__title">名前</div>
              <input
                v-model="userName"
                class="c-input__item"
                type="text"
                name="name"
                value=""
                placeholder="名前を入力してください"
              />
              <div class="c-error c-error--balloon">
                <div class="c-error__text"></div>
              </div>
            </div>
          </li>
          <!-- /名前 -->
          <!-- 権限選択 -->
          <li class="p-team-user-edit-list__item">
            <div class="c-radio">
              <div class="c-radio__title">権限</div>
              <ul class="c-radio-list">
                <li class="c-radio-list__item">
                  <label class="c-radio__label">
                    <input
                      v-model="userRole"
                      type="radio"
                      name="permission"
                      value="2"
                    />
                    <div class="c-radio__item">
                      <div class="c-radio__box"></div>
                      <div class="c-radio__box-label">サイト管理者</div>
                    </div>
                  </label>
                </li>
                <li class="c-radio-list__item">
                  <label class="c-radio__label">
                    <input
                      v-model="userRole"
                      type="radio"
                      name="permission"
                      value="3"
                    />
                    <div class="c-radio__item">
                      <div class="c-radio__box"></div>
                      <div class="c-radio__box-label">一般</div>
                    </div>
                  </label>
                </li>
              </ul>
              <div class="c-error">
                <div class="c-error__text"></div>
              </div>
            </div>
          </li>
          <!-- /権限選択 -->
          <!-- プロジェクト選択 -->
          <li class="p-team-user-edit-list__item">
            <div class="c-checkbox">
              <div class="c-checkbox__title">アクセスできるプロジェクトを選択してください</div>
              <ul class="c-checkbox-list">
                <li v-for="(service, loopIndex1) in services" :key="loopIndex1" class="c-checkbox-list__item">
                  <label class="c-checkbox__label">
                    <input
                      v-model="projects"
                      type="checkbox"
                      name="projects"
                      :value="service.service_id"
                    />
                    <div class="c-checkbox__item">
                      <div class="c-checkbox__box"></div>
                      <div class="c-checkbox__box-label">{{ service.service_name }}</div>
                    </div>
                  </label>
                </li>
              </ul>
              <div class="c-error">
                <div class="c-error__text"></div>
              </div>
            </div>
          </li>
          <!-- /プロジェクト選択 -->
        </ul>
      </div>
      <!-- /入力 | 選択リスト -->
      <!-- ボタンエリア -->
      <div class="p-team-btns">
        <a class="c-btn c-btn--gray u-w320" :href="teamUrl">
          <p class="c-btn__text">キャンセル</p>
        </a>
        <button
          class="c-btn c-btn--blue u-w320"
          :class="{ 'is-loading': isLoadingSaveBtn }"
          :disabled="isLoadingSaveBtn"
          type="button"
          name="add"
          value="add-user"
          @click="save()"
        >
          <p class="c-btn__text">{{ isEdit ? "更新する" : "追加する" }}</p>
        </button>
      </div>
      <!-- /ボタンエリア -->
    </form>
    <!-- /ユーザー情報入力エリア -->

    <!-- モーダルウィンドウ -->
    <div
      :class="[isCompleted ? 'is-active' : '']"
      class="c-modal c-modal--team-add-user"
    >
      <div class="c-modal__bg"></div>
      <div class="c-modal__content">
        <div class="c-modal__close" @click="closeModal">
          <div class="c-icon c-icon--white u-wh14">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <use xlink:href="/assets/img/sprite.svg#close" />
            </svg>
          </div>
        </div>
        <div v-if="!isEdit" class="c-modal__inner">
          <div class="c-modal__title">ユーザーが追加されました。<br />以下、内容を追加したユーザーにご案内ください。</div>
          <div class="c-modal__data">
            <button
              class="c-btn c-btn--circle"
              type="button"
              name="clip"
              value="add-user"
              :class="{ 'is-active': copyStatus === 'copied' }"
              @click="onClipClick"
            >
              <div class="c-btn__text c-btn__text--balloon">{{ copyStatus === 'copied' ? 'コピーしました' : 'クリップボードにコピー' }}</div>
              <div class="c-icon-circle c-icon-circle--white u-wh40">
                <div class="c-icon-circle__item c-icon-circle__item--gray-2 u-wh20">
                  <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <use xlink:href="/assets/img/sprite.svg#clipboard" />
                  </svg>
                </div>
              </div>
            </button>
            <dl class="c-modal-list">
              <dt class="c-modal-list__label">名前</dt>
              <dd class="c-modal-list__value">{{ addedName }}</dd>
              <dt class="c-modal-list__label">ログインID</dt>
              <dd class="c-modal-list__value">{{ addedEmail }}</dd>
              <dt class="c-modal-list__label">初期パスワード</dt>
              <dd class="c-modal-list__value">{{ addedPassword }}</dd>
              <dd class="c-modal-list__warn">※パスワードは初回ログイン時に設定してください。</dd>
              <dd class="c-modal-list__warn">※この画面を閉じると初期パスワードは再表示できません。</dd>
              <dd v-if="copyStatus === 'failed'" class="c-modal-list__warn">※コピーできませんでした。初期パスワードを手で控えてください。</dd>
            </dl>
          </div>
          <div class="c-modal__btns">
            <a class="c-btn c-btn--modal c-btn--gray u-w240 u-h34 u-fs14" :href="teamUrl" @click="onBackClick">
              <p class="c-btn__text">チームユーザーの一覧に戻る</p>
            </a>
          </div>
        </div>
        <div v-else class="c-modal__inner">
          <div class="c-modal__title">
            ユーザー情報を更新しました。<template v-if="addedPassword"><br />以下、内容をユーザーにご案内ください。</template>
          </div>
          <div class="c-modal__data">
            <button
              v-show="useCopy"
              class="c-btn c-btn--circle"
              type="button"
              name="clip"
              value="add-user"
              :class="{ 'is-active': copyStatus === 'copied' }"
              @click="onClipClick"
            >
              <div class="c-btn__text c-btn__text--balloon">{{ copyStatus === 'copied' ? 'コピーしました' : 'クリップボードにコピー' }}</div>
              <div class="c-icon-circle c-icon-circle--white u-wh40">
                <div class="c-icon-circle__item c-icon-circle__item--gray-2 u-wh20">
                  <svg
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <use xlink:href="/assets/img/sprite.svg#clipboard" />
                  </svg>
                </div>
              </div>
            </button>
            <dl class="c-modal-list">
              <dt class="c-modal-list__label">名前</dt>
              <dd class="c-modal-list__value">{{ addedName }}</dd>
              <dt class="c-modal-list__label">ログインID</dt>
              <dd class="c-modal-list__value">{{ addedEmail }}</dd>
              <template v-if="addedPassword">
                <dt class="c-modal-list__label">初期パスワード</dt>
                <dd class="c-modal-list__value">{{ addedPassword }}</dd>
                <dd class="c-modal-list__warn">※パスワードは初回ログイン時に設定してください。</dd>
                <dd class="c-modal-list__warn">※この画面を閉じると初期パスワードは再表示できません。</dd>
                <dd v-if="copyStatus === 'failed'" class="c-modal-list__warn">※コピーできませんでした。初期パスワードを手で控えてください。</dd>
              </template>
            </dl>
          </div>
          <div class="c-modal__btns">
            <a class="c-btn c-btn--modal c-btn--gray u-w240 u-h34 u-fs14" :href="teamUrl" @click="onBackClick">
              <p class="c-btn__text">チームユーザーの一覧に戻る</p>
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- /モーダルウィンドウ -->

    <!-- モーダル: エラーメッセージ表示 -->
    <error-modal
      :is-active=isError
      :message=errorMessage
      :on-close-click="onCloseErrorModal"
    />
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    teamUrl: String,
    services: Array,
    initialData: Object,
  },
  data: function() {
    return {
      isCompleted: false,
      addedName: null,
      addedEmail: null,
      addedPassword: null,
      // 'copied' | 'failed' | null
      copyStatus: null,

      email: null,
      userName: null,
      userRole: 3,
      projects: [],
      resetPassword: false,

      errorMessage: '',
      isError: false,
      isLoadingSaveBtn: false,
    };
  },
  computed: {
    isEdit: function() {
      return this.initialData != null;
    },
    useCopy: function() {
      return !this.initialData || (this.initialData != null && this.resetPassword);
    }
  },
  mounted() {
    const firstIndex = 0;
    // 編集画面のフォームを入力する
    if (this.initialData) {
      this.email = this.initialData.email;
      this.userName = this.initialData.user_name;
      this.userRole = parseInt(this.initialData.user_role)

      this.initialData.services.forEach((service) => {
        this.projects.push(service);
      });
      // 新規追加画面のフォームを入力する
    } else if(this.services.length > 0) {
      this.projects.push(this.services[firstIndex]['service_id']);
    }
  },
  methods: {
    save: function(event) {
      if (this.isEdit) {
        this.updateUser(event);
      } else {
        this.addUser(event);
      }
    },
    updateUser: function() {
      // ローディング表示設定
      this.isLoadingSaveBtn = true;

      // ペイロード作成
      const data = {
        userId: this.initialData.user_id,
        name: this.userName,
        permission: String(this.userRole),
        projects: this.projects,
        resetPassword: this.resetPassword
      };

      // 配信状況データの取得処理実行
      axios
        .post('/api/team/update', data)
        .then(res => {
          if(this.handleResponse(res)){
            this.addedName = res.data.user.name;
            this.addedEmail = res.data.user.loginId;
            this.addedPassword = res.data.user.password;
            this.copyStatus = null;
            this.isCompleted = true;

          } else {
            this.isError = true;
            this.errorMessage = (res && res.data && res.data.errors)
              ? '入力内容に誤りがあります'
              : 'ユーザーの更新に失敗しました';
          }

          setTimeout(() => {
            this.isLoadingSaveBtn = false;
          }, 300);
        })
        .catch(error => {
          this.handleHttpError(error);
          this.isError = true;
          this.errorMessage = 'ユーザーの更新に失敗しました';
          setTimeout(() => {
            this.isLoadingSaveBtn = false;
          }, 300);
        });
    },
    addUser: function (_event) {
      //event.preventDefault();

      // ローディング表示設定
      this.isLoadingSaveBtn = true;

      // ペイロード作成
      const data = {
        email: this.email,
        name: this.userName,
        permission: String(this.userRole), // 文字列型で送信しないとエラーがでるため型変換
        projects: this.projects,
      };

      // 配信状況データの取得処理実行
      axios
        .post('/api/team/add', data)
        .then(res => {
          if(this.handleResponse(res)){
            this.addedName = res.data.user.name;
            this.addedEmail = res.data.user.loginId;
            this.addedPassword = res.data.user.password;
            this.copyStatus = null;
            this.isCompleted = true;

          } else {
            this.isError = true;
            this.errorMessage = (res && res.data && res.data.errors)
              ? '入力内容に誤りがあります'
              : 'ユーザーの新規追加に失敗しました';
          }

          setTimeout(() => {
            this.isLoadingSaveBtn = false;
          }, 300);
        })
        .catch(error => {
          this.handleHttpError(error);
          this.isError = true;
          this.errorMessage = 'ユーザーの新規追加に失敗しました';
          setTimeout(() => {
            this.isLoadingSaveBtn = false;
          }, 300);
        });
    },
    // 初期パスワードは再表示できないため、コピーしていなければ閉じる前に確かめる
    confirmLeave: function() {
      if (!this.addedPassword || this.copyStatus === 'copied') {
        return true;
      }
      return window.confirm('初期パスワードを控えましたか？\nこの画面を閉じると再表示できません。');
    },
    closeModal: function(_event) {
      if (!this.confirmLeave()) {
        return;
      }
      this.isCompleted = false;
    },
    onBackClick: function(event) {
      if (!this.confirmLeave()) {
        event.preventDefault();
      }
    },
    onClipClick: function(_event) {
      // ブラウザデフォルトイベントを停止
      //event.preventDefault();

      // クリップ文字列変数を初期化
      let text = '名前 ' + this.addedName + "\n"
        + 'ログインID ' + this.addedEmail + "\n"
        + '初期パスワード ' + this.addedPassword + "\n";

      this.$copyText(text).then(() => {
        this.copyStatus = 'copied';
      }, () => {
        this.copyStatus = 'failed';
      })
    },

    // -----------------------------------------------------------------------------------------------------
    // エミット系メソッド一覧: 子孫のUI操作にフックエミットコールされるか、引き渡した関数オブジェクトからコールされるメソッド
    // -----------------------------------------------------------------------------------------------------
    // クリック: エラーモーダルを閉じる処理
    onCloseErrorModal: function() {
      this.isError = false
      this.errorMessage = ''
    },
  },
}
</script>

